import React, { useContext } from "react";
import { Link } from "gatsby";
import styled from 'styled-components';
import { GlobalContext } from "../../state/GlobalContext";
import Quote from "../simple/Quote";

const NavStyles = styled.nav`
    #menu-toggle {
        span {
            transition: transform ease-in-out .2s;
        }
    }
    #menu-toggle.active {
        span {
            background: #fff;
            
            &:nth-child(1) {
                transform-origin: 0 50%;
                transform: rotate(40deg)
            }
            &:nth-child(2) {
                transform: scale(0)
            }
            &:nth-child(3) {
                transform-origin: 0 50%;
                transform: rotate(-40deg)
            }
        }
    }
`;

function toggleMenu(e) {
    // 1. change button to active (colours)
    e.currentTarget.classList.toggle('active');
    // 2. display menu
    document.getElementById('main-menu').classList.toggle('-translate-x-full')
    document.getElementById('main-menu').classList.toggle('opacity-30')
}

export default function Nav({ showQuote }) {

    const { quoteItems } = useContext(GlobalContext);
    const quoteItemsCount = quoteItems.standard.length + quoteItems.custom.length;
    
    return (
        <NavStyles className="justify-self-end lg:">
            <button type="button" id="menu-toggle" aria-label="menu toggle" className="relative z-50 lg:hidden" onClick={toggleMenu}>
                <span className="block mb-2 h-2-px w-8 bg-primary"></span>
                <span className="block mb-2 h-2-px w-8 bg-primary"></span>
                <span className="block mb-2 h-2-px w-8 bg-primary"></span>
            </button>
            <ul id="main-menu" className="absolute top-12 left-0 z-40 h-screen lg:h-auto py-5 transform -translate-x-full opacity-30 transition duration-200 lg:flex items-center list-none bg-primary w-full lg:bg-transparent lg:w-auto lg:transform-none lg:opacity-100 lg:static lg:py-0">
                <li>
                    <a href="https://www.airproducts.com.pl/gases/specialty-gases" className="block py-2 px-4 font-bold text-white lg:text-primary" target="_blank" rel="noreferrer">Gama produktów</a>
                </li>
                <li>
                    <Link to="/dostawa" className="block py-2 px-4 font-bold text-white lg:text-primary" target="_blank" rel="noreferrer">Dostawa</Link>
                </li>
                <li className="py-2 px-4 lg:p-0">
                    <Quote showQuote={showQuote} count={quoteItemsCount} className="hidden lg:inline-block" />
                </li>
            </ul>
        </NavStyles>
    )
}